import React from 'react'
import classes from "./Loading.module.css";
import Lottie from 'lottie-react';
import animationData from "../../src/assets/animation/loading.json";

const Loading = () => {
  return (
    <div className={classes.loader}>
        <Lottie 
        animationData={animationData}
        loop={true}
        autoPlay={true}
        className={classes.animation}
        />
    </div>
  )
}

export default Loading;